import {fetch} from 'wix-fetch';

let cacheKillerCounter = 0;

const getCacheKiller = () => {
	return new Date().getTime() + cacheKillerCounter++;
};

const log = (endpoint, src, evId, params) => {
	const url = `https://frog.wix.com/${endpoint}?src=${src}&evid=${evId}&${params}&_=${getCacheKiller()}`;
	
	// const paramsKeyValue = Object.keys(params || {})
	// 						 	 .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
	const paramsKeyValue = Object.keys(params || {})
							 	 .map(key => `${key}=${params[key]}`);
	//console.log('params', encodeURIComponent(params));
	//console.log('paramsKeyValue', paramsKeyValue);
	//const body = paramsKeyValue.join('&');
	const body = '&'+encodeURIComponent(params);
	
	return fetch(url, {
		method: 'post',
		mode: 'no-cors',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		body
	});	
};

export function triggerEvent(endpoint, src, evId, params) {
	log(endpoint, src, evId, params);
}